import { render, staticRenderFns } from "./project_detail_pc.vue?vue&type=template&id=052298b5&scoped=true&"
import script from "./project_detail_pc.vue?vue&type=script&lang=js&"
export * from "./project_detail_pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052298b5",
  null
  
)

export default component.exports